// Per-step validators for the SMART-Workflow assessment.
// Pure functions only — no hooks, no React, no side effects.
// Each validator returns an error string (UI-ready) or null when the step is valid.

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const validProfile = (p) => {
  if (!p.name?.trim()) return 'Please enter your full name.';
  if (!p.email?.trim()) return 'Please enter your email address.';
  if (!EMAIL_REGEX.test(p.email)) return 'Please enter a valid email address.';
  if (!p.organization_name?.trim()) return 'Please enter your organization name.';
  return null;
};

const allAnswered = (likertGroup) =>
  Object.values(likertGroup).every(arr => arr.every(v => Number.isFinite(v) && v >= 1 && v <= 5));

const validAwasi1 = (a) =>
  allAnswered({ domain1: a.domain1, domain2: a.domain2 })
    ? null
    : 'Please answer all questions in this section before proceeding.';

const validAwasi2 = (a) =>
  allAnswered({ domain3: a.domain3, domain4: a.domain4 })
    ? null
    : 'Please answer all questions in this section before proceeding.';

const validExtended = (e) =>
  allAnswered(e) ? null : 'Please answer all questions in this section before proceeding.';

const GENERIC_WORKFLOW_NAMES = new Set([
  'a', 'b', 'c', 'd', 'x', 'y', 'z',
  'na', 'n/a', 'none', 'null', 'nil', 'nothing',
  'test', 'sample', 'example', 'demo', 'todo',
  'workflow', 'process', 'task', 'item', 'thing',
]);

export const isMeaningfulWorkflowName = (name) => {
  if (typeof name !== 'string') return false;
  const s = name.trim();
  if (!s || s.length <= 1) return false;
  if (GENERIC_WORKFLOW_NAMES.has(s.toLowerCase())) return false;
  if (s.length >= 12) return true;
  if (s.split(/\s+/).length >= 3) return true;
  return false;
};

const validFinal = (workflows, consent) => {
  const named = workflows.filter(wf => wf.name && wf.name.trim());
  if (named.length === 0) {
    return 'Please name at least one workflow you would like assessed.';
  }
  const hasMeaningful = named.some(wf => isMeaningfulWorkflowName(wf.name));
  if (!hasMeaningful) {
    return 'Please provide a more specific workflow name so the Professional Report can generate meaningful recommendations.';
  }
  if (!consent) return 'Please accept the consent agreement to continue.';
  return null;
};

export const validateStep = (step, state) => {
  switch (step) {
    case 1: return validProfile(state.profile);
    case 2: return validAwasi1(state.awasi);
    case 3: return validAwasi2(state.awasi);
    case 4: return validExtended(state.extended);
    case 5: return validFinal(state.workflows, state.consent);
    default: return null;
  }
};
